/**
 * UserPeriodListContainer
 * --
 */
import React from 'react';
import UserPeriodListPresenter from './UserPeriodListPresenter';

const UserPeriodListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <UserPeriodListPresenter />
    </>
  );
};

export default UserPeriodListContainer;
